import ErrorButton from "./ErrorButton";

export default ErrorButton;
